export const theme = {
  bg: "black",
  grey: "#3A3D40",
  toDoBg: "#5C5C60",
};
